import { Result } from "../types/Result";

export default function isIdyaResult<T = unknown>(
  data: unknown
): data is Result<T> {
  if (!data) return false;
  if (typeof data === "object" && !Array.isArray(data)) {
    return (
      "isSuccess" in data &&
      typeof data.isSuccess === "boolean" &&
      "errors" in data &&
      Array.isArray(data.errors) &&
      "statusCode" in data &&
      typeof data.statusCode === "string"
    );
  }
  return false;
}
